// @flow
import React, { useMemo } from "react";
import i18n from "i18next";

import k from "src/i18n/keys";
import { messageActionTypes } from "src/constants/chatroom";
import { setChatroomNotificationTypeFilter } from "src/actions/chatroom";
import Checkbox from "src/components/Unifize/Checkbox";
import { MenuItem } from "src/components/Unifize/Menu/MenuItem";

import type { Action, MessageFilters } from "src/types";

import { CheckboxesContainer } from "./styles";
import FilterSubmenu from "./FilterSubmenu";

type Props = {
  dispatch: (action: Action, payload: any) => void,
  filteredRecords: Array<MessageFilters>,
  menuRef: React$ElementRef<any>,
};

const RecordUpdatesMenu = ({ dispatch, filteredRecords, menuRef }: Props) => {
  const messageFilters: { [MessageFilters]: MessageFilters } = useMemo(
    () => ({
      ...Object.keys(messageActionTypes).reduce((keyStore, key) => {
        keyStore[key] = key;
        return keyStore;
      }, {}),
      deleted: "deleted",
      hidden: "hidden",
    }),
    [],
  );

  const addUpdateToNotificationFilter = (type: MessageFilters) => {
    dispatch(setChatroomNotificationTypeFilter([...filteredRecords, type]));
  };
  const removeUpdateFromNotificationFilter = (type: MessageFilters) => {
    dispatch(
      setChatroomNotificationTypeFilter(
        filteredRecords.filter((record) => record !== type),
      ),
    );
  };

  return (
    <FilterSubmenu menuRef={menuRef}>
      <CheckboxesContainer>
        <MenuItem
          padding="0 0.5rem"
          height="xl"
          hoverColor="rgba(133, 133, 133, 0.05)"
          display="inline"
        >
          <Checkbox
            label={i18n.t(k.MESSAGES)}
            checked={!filteredRecords.includes(messageFilters.messages)}
            onChange={(checked) => {
              if (checked) {
                removeUpdateFromNotificationFilter(messageFilters.messages);
              } else {
                addUpdateToNotificationFilter(messageFilters.messages);
              }
            }}
            labelFullWidth
            height="100%"
          />
        </MenuItem>
        <MenuItem
          padding="0 0.5rem"
          height="xl"
          hoverColor="rgba(133, 133, 133, 0.05)"
          display="inline"
        >
          <Checkbox
            label={i18n.t(k.CHECKLIST_UPDATES)}
            checked={!filteredRecords.includes(messageFilters.checklist)}
            onChange={(checked) => {
              if (checked) {
                removeUpdateFromNotificationFilter(messageFilters.checklist);
              } else {
                addUpdateToNotificationFilter(messageFilters.checklist);
              }
            }}
            labelFullWidth
            height="100%"
          />
        </MenuItem>
        <MenuItem
          padding="0 0.5rem"
          height="xl"
          hoverColor="rgba(133, 133, 133, 0.05)"
          display="inline"
        >
          <Checkbox
            label={i18n.t(k.METADATA_UPDATES)}
            checked={!filteredRecords.includes(messageFilters.metadata)}
            onChange={(checked) => {
              if (checked) {
                removeUpdateFromNotificationFilter(messageFilters.metadata);
              } else {
                addUpdateToNotificationFilter(messageFilters.metadata);
              }
            }}
            labelFullWidth
            height="100%"
          />
        </MenuItem>
        <MenuItem
          padding="0 0.5rem"
          height="xl"
          hoverColor="rgba(133, 133, 133, 0.05)"
          display="inline"
        >
          <Checkbox
            label={i18n.t(k.DELETED)}
            checked={!filteredRecords.includes(messageFilters.deleted)}
            onChange={(checked) => {
              if (checked) {
                removeUpdateFromNotificationFilter(messageFilters.deleted);
              } else {
                addUpdateToNotificationFilter(messageFilters.deleted);
              }
            }}
            labelFullWidth
            height="100%"
          />
        </MenuItem>
        <MenuItem
          padding="0 0.5rem"
          height="xl"
          hoverColor="rgba(133, 133, 133, 0.05)"
          display="inline"
        >
          <Checkbox
            label={i18n.t(k.HIDDEN)}
            checked={!filteredRecords.includes(messageFilters.hidden)}
            onChange={(checked) => {
              if (checked) {
                removeUpdateFromNotificationFilter(messageFilters.hidden);
              } else {
                addUpdateToNotificationFilter(messageFilters.hidden);
              }
            }}
            labelFullWidth
            height="100%"
          />
        </MenuItem>
      </CheckboxesContainer>
    </FilterSubmenu>
  );
};

export default RecordUpdatesMenu;
